import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import partsRow from "./Plugin/partsRowTable.vue";
import detailsTable from "./Plugin/detailsTable.vue"
import {
  domainName,
  processApi
} from "../../../utility/index"
import moment from "moment";

export default {
  name: 'RepairManagement',
  components: {
    tree,
    iTable,
    IPagination,
    partsRow,
    detailsTable
  },
  data() {
    return {
      isCollapse: false,
      stateArrow: true,
      isSearch: true,
      id: '',
      formInline: {
        selectCarType: '',
        selectCarValue: '',
        // contactName: '',
        MaintainTime: [],
      },
      optionsInput: [{
        value: '0',
        label: this.$t('common.all')
      }, {
        value: '1',
        label: this.$t('common.carId')
      }, {
        value: '2',
        label: this.$t('common.plateNum')
      }, {
        value: '3',
        label: this.$t('common.customNum')
      },
      {
        value: '4',
        label: this.$t('common.manufactureNum')
      }
      ],
      carList: [],
      height: '550',
      list: [],
      option: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: true,
        serialNumber: true,
      },
      columns: [{
        prop: "serialNumber",
        label: this.$t('VehicleManagement.serialNumber'),
        align: "center",
        width: "180px"
      },
      {
        prop: "carId",
        label: this.$t('common.carId'),
        align: "center",
      },
      {
        prop: "manufactureNum",
        label: this.$t('common.manufactureNum'),
        align: "center",
        width: "150px"
      },
      {
        prop: "customNum",
        label: this.$t('common.customNum'),
        align: "center",
        width: "120px"
      },
      {
        prop: "plateNum",
        label: this.$t('common.plateNum'),
        align: "center",
        width: "120px"
      },
      {
        prop: "userName",
        label: this.$t('VehicleManagement.maintenancePerson'),
        align: "center",
        width: "120px"
      },
      {
        prop: "repairTypeStr",
        label: this.$t('Details.faultClassification'),
        align: "center",
        width: "160px"

      },
      // {
      //   prop: "repairType",
      //   label: this.$t('Details.faultClassification'),
      //   align: "center",
      //   width: "120px",
      //   render: (h, params) => {
      //     return h('el-tag', {
      //       props: {
      //         type: params.row.repairType === '' ? '' : params.row.repairType === 0 ? 'danger' : params.row.repairType === 1 ? 'warning' : params.row.repairType === 2 ? 'success' : 'info'
      //       }
      //     }, params.row.repairType === '' ? '' : params.row.repairType === 0 ? this.$t('VehicleManagement.unaccepted') : params.row.repairType === 1 ? this.$t('VehicleManagement.repaired') : params.row.repairType === 2 ? this.$t('VehicleManagement.alreadyRepaired') : this.$t('VehicleManagement.closed'))
      //   }

      // },
      {
        prop: "peopleCost",
        label: this.$t('VehicleManagement.peopleCost'),
        align: "center",
        width: "120px"
      },

      {
        prop: "materialCost",
        label: this.$t('Details.materialCost'),
        align: "center",
        width: "200px"
      },
      {
        prop: "sumCost",
        label: this.$t('Details.totalCost'),
        align: "center",
        width: "160px"
      },
      {
        prop: "operateTime",
        label: this.$t('VehicleManagement.operateTime'),
        align: "center",
        width: "180px",
        // render: (h, params) => {
        //   return h('span', this.$formatTime(params.row.operateTime))
        // }
      },

      ],
      // dialogDetailsFormVisible: false,
      operates: {
        width: 120,
        fixed: "right",
        list: [{
          id: '1',
          show: true,
          icon: 'iconfont iconicon-chakanxq',
          plain: true,
          disabled: false,
          isBtn: "REPAIRFORM_DETAIL",
          method: (index, row) => {
            console.log(row)
            this.dialogOperateVisible = true
            this.queryDetails(row)
            // this.$router.push({
            //   path: '/VehicleManagement/RepairManagement/Details',
            //   query: {
            //     requestSerialNumber: row.requestSerialNumber,
            //     tabName: 'first'
            //   }
            // })
          }
        }],
      },
      currentPage: 1,
      pageSize: 10,
      total: 1,
      dialogFormVisible: false,
      formLabelWidth: '112px',
      diaTitle: '',
      btnType: '',
      rules: {
        carId: [{
          required: true,
          message: this.$t('TopBar.form.carId'),
          trigger: 'change'
        }],
        // contactName: [
        //     { required: true, message: this.$t('TopBar.form.contactName'), trigger: 'blur' }
        // ],
        happenTime: [{
          required: true,
          message: this.$t('TopBar.form.happenTime'),
          trigger: 'change'
        }],
        phone: [{
          required: true,
          message: this.$t('TopBar.form.phone'),
          trigger: 'blur'
        }],
      },
      form: {
        carId: '',
        userId: '',
        userName: '',
        operateTime: '',
        repairType: '1',
        repairDescription: '',
        peopleCost: '',
        materialCost: '',
        allCost: '',
        filePath: '',
        repairContent: ''
      },
      selected: [],
      orgId: '',
      imageUrl: '',
      dialogVisible: false,
      processImg: processApi,
      FileList: [],
      filePath: '',
      requestSerialNumber: '',

      OperateForm: {
        serialNumber: '',
        userName: '',
        operateTime: '',
        repairTypeStr: '',
        description: '',
        peopleCost: '',
        materialCost: '',
        sumCost: '',
        filePath: ''
      },
      dialogOperateVisible: false,
      FileOperateList: [],
      dialogFileOperateVisible: false,
      imageOperateUrl: '',
      OperateLabelWidth: '126px',
    }
  },
  computed: {
    materialCost() {
      this.form.allCost = Number(this.form.peopleCost) + Number(this.form.materialCost)
      return this.form.allCost
    },
  },
  watch: {
    materialCost(val) {
      this.form.allCost = val
    },
  },
  mounted() {
    this.getFaultType('query')
  },
  methods: {
    toggleSideBar() {
      this.isCollapse = !this.isCollapse
      this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
    },
    changeArrow() {
      this.stateArrow = !this.stateArrow
    },
    initQuery(item) {
      console.log(item)
      this.orgId = item.id
      this.getRepairList()
    },
    nodeClick(val) {
      this.orgId = val.label
      this.getRepairList()
    },

    computedPrice(num) {
      console.log(num)
      this.form.materialCost = num
    },
    getRepairList() {
      let startTime = ''
      let endTime = ''
      if (this.formInline.MaintainTime) {
        if (this.formInline.MaintainTime.length > 0) {
          startTime = this.formInline.MaintainTime[0];
          endTime = this.formInline.MaintainTime[1];
        }
      }
      let param = {
        orgId: this.orgId,
        selectCarType: this.formInline.selectCarType,
        selectCarValue: this.formInline.selectCarValue,
        // contactName: this.formInline.contactName,
        startTime: startTime,
        endTime: endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }
      this.$store.dispatch('CarRepair/GET_GETCARREPAIRLIST', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.list = res.data.data.list
            this.$refs.page.CommandTotal = res.data.data.total
          }
        }
      }).catch(err => { })
    },
    getFaultType(type) {
      this.$store.dispatch('DictionaryManaged/GET_SELECTMALFUNCTIONTYPE', {}).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.typeList = res.data.data
          }
        }
      }).catch(err => { })
    },
    onSearch() {
      this.currentPage = 1
      this.getRepairList()
    },
    onClear() {
      this.formInline = {
        selectCarType: '',
        selectCarValue: '',
        MaintainTime: [],
      }
      this.getRepairList()
    },
    getCarList() {
      let param = {
        orgId: this.orgId
      }
      this.$store.dispatch('RepairManagement/GET_GETCARMESSAGE', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.carList = res.data.data.list
          }
        }
      }).catch(err => { })
    },
    addMaintain() {
      this.dialogFormVisible = true
      // this.diaTitle = this.$t('common.btn.add')
      // this.btnType = 'add'
      // this.form.carId = this.selected[0].carId
      this.form.userName = sessionStorage.getItem("username")
      this.form.operateTime = moment().format("YYYY-MM-DD HH:mm:ss")
      this.form.repairType = ''
      this.form.filePath = ''
      this.FileList = []
      this.getFaultType('add')
      this.getCarList()
      this.$nextTick(() => {
        this.$refs.diaTable.tableData = []
        this.$refs.form.resetFields()
      })
    },
    handlePictureCardPreview(file) {
      this.imageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      this.FileList = []
      const arr = []
      fileList.map((item) => {
        this.FileList.push({
          name: item.name,
          url: item.url,
          uid: item.uid
        })
        arr.push(item.url)
      })
      this.form.filePath = arr.join(',')
    },

    handleAvatarSuccess(res, file) {
      const arr = []
      this.FileList.push({
        url: res[0],
      })
      this.FileList.map(item => {
        arr.push(item.url)
      })
      this.form.filePath = arr.join(',')
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            userId: sessionStorage.getItem("userId"),
            carId: this.form.carId,
            // userId: this.form.operateUser,
            operateTime: this.form.operateTime,
            repairType: this.form.repairType,
            repairDescription: this.form.repairDescription,
            peopleCost: this.form.peopleCost,
            filePath: this.form.filePath,
            repairContent: JSON.stringify(this.$refs.diaTable.tableData),
            materialCost: this.form.materialCost
          }
          this.$store.dispatch('CarRepair/GET_INSERTCARREPAIR', param).then(res => {
            if (res.data.code == 200) {
              this.$message.success(this.$t('common.repairSuccess'))
              this.dialogFormVisible = false;
              this.getRepairList();
              this.closeDia();
            } else {
              this.$message.error(res.data.msg)
            }

          }).catch(err => { })



        }
      });
    },
    cancle(formName) {
      this.dialogFormVisible = false;
      this.form = {
        carId: '',
        userId: '',
        userName: '',
        operateTime: '',
        repairType: '1',
        repairDescription: '',
        peopleCost: '',
        materialCost: '',
        allCost: '',
        filePath: '',
        repairContent: ''
      }
      this.$nextTick(() => {
        this.$refs.diaTable.tableData = []
      })
    },
    closeDia() {
      this.form = {
        carId: '',
        userId: '',
        userName: '',
        operateTime: '',
        repairType: '1',
        repairDescription: '',
        peopleCost: '',
        materialCost: '',
        allCost: '',
        filePath: '',
        repairContent: ''
      }
      this.$nextTick(() => {
        this.$refs.diaTable.tableData = []
      })
      this.dialogFormVisible = false;
    },

    down() {
      if (domainName) {
        let startTime = ''
        let endTime = ''
        if (this.formInline.MaintainTime) {
          if (this.formInline.MaintainTime.length > 0) {
            startTime = this.formInline.MaintainTime[0];
            endTime = this.formInline.MaintainTime[1];
          }
        }
        if (domainName.split(':')[0] !== 'localhost') {
          let url = `https://${domainName}/v1/getExportExcel/exportCarRepair?orgId=${this.orgId}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&startTime=${startTime}&endTime=${endTime}`
          location.href = url
        } else {
          let host = 'localhost:8080'
          let url = `https://${host}/v1/getExportExcel/exportCarRepair?orgId=${this.orgId}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&startTime=${startTime}&endTime=${endTime}`
          location.href = url
        }
      }
    },

    closeOperateDia() {
      this.dialogOperateVisible = false
    },
    queryDetails(row) {
      let param = {
        serialNumber: row.serialNumber,
      }
      this.$store.dispatch('CarRepair/GET_GETREPAIR', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.$nextTick(() => {
              this.OperateForm = res.data.data
              // this.OperateForm = {
              //   requestSerialNumber: res.data.data.requestSerialNumber,
              //   carId: res.data.data.carId,
              //   carWorkTime: res.data.data.carWorkTime,
              //   operateUser: res.data.data.operateUser,
              //   operateTime: res.data.data.operateTime,
              //   repairType: res.data.data.repairTypeStr,
              //   remarks: res.data.data.remarks,
              //   peopleCost: res.data.data.peopleCost,
              //   materialCost: res.data.data.materialCost,
              //   filePath: res.data.data.filePath
              // }
              this.FileOperateList = [];
              const arr = res.data.data.filePath.split(',')
              arr.forEach(filePath => {
                this.FileOperateList.push({
                  url: filePath,
                });
              });
              // this.$refs.detailTable.id = res.data.data.serialNumber
              // this.$refs.detailTable.getDetailList()
              this.$refs.detailTable.tableData = res.data.data.material
            })
          }
        }
      }).catch(err => { })
    },
    handleOperatePictureCardPreview(file) {
      this.imageOperateUrl = file.url;
      this.dialogFileOperateVisible = true;
    },
    handleSelectionChange(val) {
      this.selected = val
    },
    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getRepairList();
    },

    onResize: function (x, y, width, height) {
      let box = document.getElementById("leftBox");
      box.style.width = width + "px";
    },
  }
}